import { Component, h, useState } from "@lukekaalim/act";
import { GamesState } from "../../hooks";
import { ModalComponent, useAsync } from "@kosmod/kit";
import { Game } from "../../defs";
import { html } from "@lukekaalim/act-web";
import { useFrontendServices } from "@kosmod/core";
import { LabeledInput } from "../Authenticate";

export type InvitationManagerProps = {
  game: Game,
  games: GamesState,

  refresh(): void,
  refreshKey: number,
}

export const InvitationManager: Component<InvitationManagerProps> = ({ games, game, refresh, refreshKey }) => {
  const { result: invitations } = useAsync(async () => {
    const { invitations } = await games.api.invitation.GET({ invitationId: null, gameId: game.id }, null);
    return invitations;
  }, [refreshKey])
  const { modal } = useFrontendServices();

  const onClickCreateInvite = async () => {
    const name = await modal.add(EnterNamePopup)
    if (!name)
      return;

    const invitation = await games.createInvitation(game.id, name)
    refresh();
  };

  return [
    h('button', { onClick: onClickCreateInvite }, 'Create Invite Link'),

    !!invitations && h(html.ol, {}, invitations.map(invitation => {
      return h(html.li, {}, [
        h(html.div, {}, `To: ${invitation.addressedTo}`),
        h(html.pre, {}, invitation.encodedURL),
        h(html.button, {}, 'Delete')
      ])
    }))
  ]
};

const EnterNamePopup: ModalComponent<string> = ({ submit }) => {
  const [name, setName] = useState('');

  return h(html.form, { onSubmit(event: SubmitEvent) {
    event.preventDefault();
    submit(name)
  },}, [
    h(LabeledInput, {
      label: 'Enter new game name',
      name: 'gamename',
      placeholder: 'Cool Game',
      value: name,
      onInput(event) {
        setName(this.value);
      },
    }),
  ])
}